import * as api from '../api';

/* eslint-disable import/prefer-default-export */
export const fetchUtilityUnits = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/utilities/units`, args);
};
